export const solarConfigSheets: any[] = [
    {
        "name": "Static Data",
        "id": "statics"
    },
    {
        "name": "Master",
        "id": "master"
    },
    {
        "name": "Degradation",
        "id": "degradation"
    },
    {
        "name": "SMB",
        "id": "smbs"
    },
    {
        "name": "Strings",
        "id": "strings"
    },
    {
        "name": "Map Coordinates",
        "id": "maps_coordinates"
    },
    {
        "name": "Tags",
        "id": "tags"
    },
    {
        "name": "Equipments",
        "id": "equipments"
    },
    {
        "name": "Plant Overview",
        "id": "overview"
    },
    {
        "name": "Monthly Budgets",
        "id": "monthly_budgets"
    },
    {
        "name": "Alarms",
        "id": "alarms"
    },
    {
        "name": "Default Alarms",
        "id": "default_alarms"
    },
    {
        "name": "Equipments Registry",
        "id": "eqp_reg"
    }
]
export const windConfigSheets: any[] = [
    {
        "name": "Static Data",
        "id": "statics"
    },
    {
        "name": "Structure",
        "id": "w_master"
    },
    {
        "name": "Air Density Corrected Power Cur",
        "id": "w_power_curve"
    },
    {
        "name": "Tags",
        "id": "w_tags"
    },
    {
        "name": "Alarms",
        "id": "w_alarms"
    },
    {
        "name": "Default Alarms",
        "id": "w_default_alarms"
    }
]